import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgFor } from '@angular/common'
import { FormsModule } from '@angular/forms'

@Component({
	selector: 'app-tag-selector',
	templateUrl: './tag-selector.component.html',
	styleUrls: ['./tag-selector.component.scss'],
	standalone: true,
	imports: [FormsModule, NgFor],
})
export class TagSelectorComponent {
	@Input() tags: string[] = []
	@Output() tagsChange = new EventEmitter<any>()
	newTags: string
	constructor() {}

	addTags() {
		this.tagsChange.emit(this.newTags.split(',').map((x) => x.trim()))
	}

	removeTag(tag: string) {
		this.tagsChange
	}
}
